import {useCallback, useState} from 'react';
import * as React from 'react';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import {TopicItemInfo, TopicModule} from '../../services/pages/channel/channel.client';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

const SelfTopicImgDoubleColumn = ({infos, page, channelBusinessLine}: Props) => {

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        (linkUrl?: string, swanUrl?: string, card?) => {
            const urlParams = {
                linkUrl,
                swanUrl,
            };
            const logParams = {
                page: page,
                value: 'jump_tupian_shuanglietu',
                channelId: infos?.channelId,
                pageType: channelBusinessLine,
                moduleId: infos?.moduleId,
                moduleName: infos?.moduleName,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: card.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: card.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [channelBusinessLine, infos.channelId, infos.moduleId, infos.moduleName, page, navigateToUrl]
    );

    const maxColumn = 2;

    const [columns] = useState<number[]>([1, 2]);

    const renderColumn = (column: number, itemList: TopicItemInfo[]) => {
        return (
            itemList.length >= column
                ? (
                    <div className={styles.parent}>
                        {
                            itemList.map(
                                (card, index) => (
                                    (index + 1) % maxColumn === ((maxColumn === column) ? 0 : column)
                                        ? (
                                            <div
                                                key={card.itemId}
                                                onClick={
                                                    () => handleClick(
                                                        card.fieldValue?.link, card.fieldValue?.swanUrl, card
                                                    )
                                                }
                                                className={styles.card}
                                                data-show={JSON.stringify({
                                                    'page': page,
                                                    'value': 'jump_tupian_shuanglietu',
                                                    'pageSourceId': card.channelId,
                                                    'pageType': channelBusinessLine,
                                                    'valueId': card.itemId,
                                                    'valueTitle': card.title,
                                                    'valueType': VALUE_TYPE.ITEM,
                                                })}
                                            >
                                                <img
                                                    onClick={() => {}}
                                                    src={card.fieldValue?.img}
                                                    className={styles.imgCard}
                                                    style={{
                                                        borderRadius: infos.moduleFillet === 1 ? '0' : '12px',
                                                    }}
                                                />
                                            </div>
                                        )
                                        : null
                                )
                            )
                        }
                    </div>
                )
                : null
        );
    };


    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_tupian_shuanglietu',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >

            {
                (infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle))
                    ? (
                        <div className={styles.titleParent}>
                            <div className={styles.titleContent}>
                                {
                                    infos.moduleName
                                        ? (
                                            <span className={styles.title}>
                                                {infos.moduleName}
                                            </span>
                                        )
                                        : null
                                }
                                {
                                    infos.moduleSubTitle
                                        ? (
                                            <span className={styles.subTitle}>
                                                {infos.moduleSubTitle}
                                            </span>
                                        )
                                        : null
                                }
                            </div>
                            <div>
                                {
                                    infos.moreUrl
                                        ? (
                                            <img
                                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                                                className={styles.rightMoreArrow}
                                                onClick={() => {
                                                    handleClick(infos.moreUrl);
                                                }}
                                            />
                                        )
                                        : null
                                }
                            </div>
                        </div>
                    )
                    : null
            }

            <div className={styles.container}>

                {
                    columns.map(
                        column => (
                            renderColumn(column, infos.itemList || [])
                        )
                    )
                }

            </div>

        </div>
    );
};

export default SelfTopicImgDoubleColumn;
